<template>
  <main class="access-denied">
    <div class="access-denied__card">
      <div class="access-denied__icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M3 8.5V17a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5M3 8.5l9 6 9-6M3 8.5V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.5"
            stroke="#3b82f6"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M7 12.5l3 2.5 7-5.5"
            stroke="#3b82f6"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h2 class="access-denied__title">邀请测试中</h2>
      <p class="access-denied__subtitle">
        当前产品处于邀请测试阶段，您可以前往社区申请名额
      </p>
      <a
        href="https://bbs.wps.cn/topic/88713"
        target="_blank"
        rel="noopener noreferrer"
        class="access-denied__btn"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        前往社区申请
      </a>
    </div>
  </main>
</template>

<style scoped>
.access-denied {
  background-color: #f8fafc;
  min-height: calc(100vh - 61px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.access-denied::before {
  content: '';
  position: absolute;
  top: -20%;
  left: -10%;
  width: 120%;
  height: 120%;
  background:
    radial-gradient(circle at 20% 30%, rgba(255, 204, 204, 0.4) 0%, transparent 40%),
    radial-gradient(circle at 80% 20%, rgba(204, 229, 255, 0.5) 0%, transparent 50%),
    radial-gradient(circle at 50% 60%, rgba(255, 240, 204, 0.4) 0%, transparent 50%);
  filter: blur(60px);
  z-index: 0;
  pointer-events: none;
}

.access-denied__card {
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.08), 0 2px 10px rgba(0, 0, 0, 0.02);
  padding: 48px 40px;
  text-align: center;
  max-width: 480px;
  width: 90%;
  position: relative;
  z-index: 1;
}

.access-denied__icon {
  width: 64px;
  height: 64px;
  background: #eff6ff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.access-denied__title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 12px;
}

.access-denied__subtitle {
  color: #6b7280;
  font-size: 15px;
  line-height: 1.625;
  margin: 0 0 32px;
}

.access-denied__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1e293b;
  color: white;
  padding: 14px 32px;
  border-radius: 16px;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: 0 8px 20px rgba(30, 41, 59, 0.2);
  margin-top: 8px;
  border: none;
  cursor: pointer;
}

.access-denied__btn:hover {
  background: #0f172a;
  transform: translateY(-2px);
}

.access-denied__btn:active {
  transform: translateY(0);
}
</style>
